module.exports = __webpack_public_path__ + "img/Camera&lens3.e53a994f.png";